import React, { useEffect, useState } from 'react';

import { getDashboardSummary } from 'actions/rules';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { DashboardReportPeriod } from 'models/dashboardReports';
import DashboardReports from 'screens/components/DashboardReports';

const DashboardReportsContainer = () => {
  const [dashboardReports, setDashboardReports] = useState<DashboardReportPeriod[]>([]);
  const [isLoading, setLoading] = useState(true);
  const toast = useToast();
  const { t } = useStoreTranslation();

  useEffect(() => {
    const fetchDashboardReports = async () => {
      try {
        const {
          data: {
            data: { periods },
          },
        } = await getDashboardSummary();
        setDashboardReports(periods);
        setLoading(false);
      } catch (error) {
        toast.add({ type: 'danger', message: t('rulesComponent.listError') });
        setLoading(false);
      }
    };
    fetchDashboardReports();
  }, [t, toast]);

  return <DashboardReports dashboardReports={dashboardReports} isLoading={isLoading} />;
};

export default DashboardReportsContainer;
